export default "__VITE_ASSET__B996Bt4T__"